import { useNavigate } from 'react-router';
import { useWrapRequest } from '@components/hooks/use-wrap-request';
import { Api } from '@core/api';
import { links } from '@core/router';
import { injectTSDI } from '@core/tsdi';
import { CreateCompositePointDefinitionRequestDto } from '@api/FitnessActivityClient';

export function useCreatePointDefinitionStore(communityId: number) {
    const { fitnessActivityClient } = injectTSDI(Api);
    const navigate = useNavigate();

    const createRequest = useWrapRequest(
        async (data: CreateCompositePointDefinitionRequestDto) =>
            fitnessActivityClient.admin.compositePointDefinitionControllerCreate(
                data
            ),
        { successMessage: () => 'Point definition created successfully' }
    );

    const onSubmit = async (
        data: CreateCompositePointDefinitionRequestDto
    ) => {
        const response = await createRequest.request([data], { throwError: true });
        if (response) {
            navigate(links.communityPointDefinitions(String(communityId)));
        }
    };

    return { createRequest, onSubmit };
}
